import { render, staticRenderFns } from "./LogoLoading.vue?vue&type=template&id=35bf8356&scoped=true"
var script = {}
import style0 from "./LogoLoading.vue?vue&type=style&index=0&id=35bf8356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bf8356",
  null
  
)

export default component.exports